import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FiLock } from 'react-icons/fi';

const AdminLogin = () => {
  const [adminKey, setAdminKey] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Add this useEffect to check if the environment variable is loaded
  useEffect(() => {
    console.log('Admin Key from env:', process.env.REACT_APP_ADMIN_KEY);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const correctKey = process.env.REACT_APP_ADMIN_KEY;
    
    // Add debugging logs
    console.log('Entered key:', adminKey);
    console.log('Correct key:', correctKey);
    console.log('Keys match:', adminKey === correctKey);
    
    if (!correctKey) {
      setError('Admin key not configured. Please check your .env file.');
      return;
    }
    
    if (adminKey === correctKey) {
      // Store authentication in sessionStorage
      sessionStorage.setItem('adminAuthenticated', 'true');
      navigate('/admin');
    } else {
      setError('Invalid admin key');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0B1120] via-[#132037] to-[#1B2B4B] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-md"
      >
        <div className="bg-[#1E293B]/70 backdrop-blur-sm border border-[#334155]/30 rounded-xl p-8 shadow-xl">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500 mb-2">
              Admin Access
            </h1>
            <p className="text-[#94A3B8]">Enter admin key to continue</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiLock className="text-[#64748B]" />
              </div>
              <input
                type="password"
                value={adminKey}
                onChange={(e) => setAdminKey(e.target.value)}
                placeholder="Enter Admin Key"
                className="w-full pl-10 pr-4 py-3 bg-[#0F172A]/50 border border-[#334155]/50 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>

            {error && (
              <motion.p
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-red-500 text-center"
              >
                {error}
              </motion.p>
            )}

            <motion.button
              type="submit"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="w-full py-3 px-4 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white rounded-lg font-medium transition-all duration-300"
            >
              Access Dashboard
            </motion.button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default AdminLogin; 